import styled from "styled-components";

export enum OutageSystemAreas {
    start = "start",
    end = "end",
}

export const OutageSystemLayout = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(200px, 300px));
`;
